"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Config = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _stateApi = _interopRequireDefault(require("../util/stateApi"));
var _storeProvider = _interopRequireWildcard(require("./../util/storeProvider"));
var _ConfigPage = _interopRequireDefault(require("../ConfigPage"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class Config extends _react.PureComponent {
  render() {
    const store = new _stateApi.default();
    store.initialize(this.props.initProps);
    return /*#__PURE__*/React.createElement(_ConfigPage.default, {
      store: store
    });
  }
}
exports.Config = Config;
Config.propTypes = {
  initProps: _propTypes.default.shape({
    environment: _propTypes.default.string,
    packageId: _propTypes.default.string,
    plid: _propTypes.default.int,
    xs: _propTypes.default.int,
    src: _propTypes.default.string,
    itc: _propTypes.default.string,
    content: _propTypes.default.object,
    atb: _propTypes.default.string
  })
};
Config.contextType = _storeProvider.default;
var _default = exports.default = (0, _storeProvider.provideContext)(Config);